import React from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import useFirebaseStore from '@di-shared/features/environment/firebaseStore';
import {WebviewUtils} from '@shared/webviewUtils';

function LicenseRenewalFailSystemErrorBottomSheet() {
  const {t} = useInferableTranslation();
  const {getExternalVariable} = useFirebaseStore(({getExternalVariable}) => ({getExternalVariable}));
  return (
    <div className="bottom_sheet">
      <div className="bottom_sheet_header">
        <h2 className="bottom_sheet_title">{t('T10226')}</h2>
        <button
          type="button"
          className="btn btn_ic"
          aria-label={t('T10017')}
          onClick={() => window.bottomSheetClose()}
        >
          <span
            className="ic ic_close_20px"
            aria-hidden="true"
          />
        </button>
      </div>
      <div className="bottom_sheet_inner">
        <div className="bottom_sheet_contents">
          <strong className="bottom_sheet_title_sub">{t('T10294')}</strong>
          <div className="bottom_sheet_box">
            <div className="divider" />
            <p className="bottom_sheet_text">{t('T10295')}</p>
            <p className="bottom_sheet_text">{t('T10296')}</p>
            <p className="bottom_sheet_text">{t('T10297')}</p>
            <p className="bottom_sheet_text">{t('T10298')}</p>
            <div className="divider" />
          </div>
          <strong className="bottom_sheet_title_sub">{t('T10228_$link', {link: getExternalVariable('LICENSE_RENEWAL_URL')})}</strong>
        </div>
        <div className="bottom_sheet_footer bottom_sheet_footer_complex">
          <button
            type="button"
            className="btn btn_large btn_outline"
            onClick={() => window.bottomSheetClose()}
          >
            {t('T10221')}
          </button>
          <button
            type="button"
            className="btn btn_large btn_filled"
            onClick={() => WebviewUtils.openWebBrowser(getExternalVariable('LICENSE_RENEWAL_URL'))}
          >
            {t('T10232')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default LicenseRenewalFailSystemErrorBottomSheet;
